import { Link } from "react-router-dom";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiArrowUpRight } from "react-icons/fi";

const ecosystem = [
  { label: "Digital Brain", href: "https://brain.rakeshkadam.me" },
  { label: "Portfolio", href: "https://rakeshkadam.me" },
  { label: "Blog", href: "https://medium.com/@rakeshkadam" },
  { label: "GitHub", href: "https://github.com/rakesh-kadam" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/rakeshkadam" },
  { label: "X / Twitter", href: "https://x.com/notrakeshkadam" },
];

const resources = [
  { label: "CKA Course", href: "https://brain.rakeshkadam.me/" },
  { label: "Kubernetes Notes", href: "https://brain.rakeshkadam.me/" },
  { label: "AI & LLMs", href: "https://brain.rakeshkadam.me/" },
  { label: "System Design", href: "https://brain.rakeshkadam.me/" },
];

const siteLinks = [
  { label: "About", to: "/about" },
  { label: "Skills", to: "/skills" },
  { label: "Certifications", to: "/certificates" },
  { label: "Contact", to: "/contact" },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-light-border dark:border-border-subtle bg-light-surface dark:bg-surface-1">
      <div className="mx-auto max-w-6xl px-6 py-10 md:px-10">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          {/* Identity */}
          <div className="col-span-2 md:col-span-1">
            <Link
              to="/"
              className="inline-block text-base font-bold text-light-text dark:text-text-primary tracking-tight hover:text-accent dark:hover:text-accent transition-colors"
            >
              Rakesh Kadam
            </Link>
            <p className="mt-1.5 font-mono text-xs text-light-muted dark:text-text-muted">
              DevSecOps Lead & AI Enthusiast
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://github.com/rakesh-kadam"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="text-light-muted transition-colors hover:text-accent dark:text-text-muted dark:hover:text-accent"
              >
                <FaGithub size={17} />
              </a>
              <a
                href="https://www.linkedin.com/in/rakeshkadam"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-light-muted transition-colors hover:text-accent dark:text-text-muted dark:hover:text-accent"
              >
                <FaLinkedin size={17} />
              </a>
              <a
                href="https://x.com/notrakeshkadam"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X / Twitter"
                className="text-light-muted transition-colors hover:text-accent dark:text-text-muted dark:hover:text-accent"
              >
                <FaXTwitter size={17} />
              </a>
            </div>
          </div>

          {/* Ecosystem */}
          <div>
            <p className="mb-3 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-light-muted dark:text-text-faint">
              Ecosystem
            </p>
            <ul className="space-y-2">
              {ecosystem.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-1 text-sm text-light-muted transition-colors hover:text-accent dark:text-text-muted dark:hover:text-accent"
                  >
                    {link.label}
                    <FiArrowUpRight
                      size={10}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <p className="mb-3 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-light-muted dark:text-text-faint">
              Resources
            </p>
            <ul className="space-y-2">
              {resources.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-1 text-sm text-light-muted transition-colors hover:text-accent dark:text-text-muted dark:hover:text-accent"
                  >
                    {link.label}
                    <FiArrowUpRight
                      size={10}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Site */}
          <div>
            <p className="mb-3 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-light-muted dark:text-text-faint">
              Site
            </p>
            <ul className="space-y-2">
              {siteLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-light-muted transition-colors hover:text-accent dark:text-text-muted dark:hover:text-accent"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-light-border pt-6 dark:border-border-subtle">
          <p className="text-center font-mono text-xs text-light-muted dark:text-text-faint tracking-wide">
            &copy; {year} Rakesh Kadam &middot; Built with React + TypeScript
            + Tailwind + Vite
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
